import React, { useEffect, useState } from "react";
import {
  Button,
  TextField,
  Switch,
  Checkbox,
  IconButton,
  Typography,
  Modal,
  TableContainer,
  Table,
  TableHead,
  TableRow,
  TableCell,
  TableBody,
} from "@mui/material";
import "../../.././pages/Scheduler.css";

/*MUI Icon Import*/
import DeleteIcon from "@mui/icons-material/Delete";
import CalendarMonthIcon from "@mui/icons-material/CalendarMonth";
import CloseIcon from "@mui/icons-material/Close";
import EditCalendarIcon from "@mui/icons-material/EditCalendar";

/* MUI Date-Time Picker */
import { AdapterDayjs } from "@mui/x-date-pickers/AdapterDayjs";
import { DateTimePicker } from "@mui/x-date-pickers/DateTimePicker";
import { LocalizationProvider } from "@mui/x-date-pickers/LocalizationProvider";

/* MUI Dropdown */
import Box from "@mui/material/Box";
import InputLabel from "@mui/material/InputLabel";
import MenuItem from "@mui/material/MenuItem";
import FormControl from "@mui/material/FormControl";
import Select from "@mui/material/Select";
import { TimePicker } from "@mui/x-date-pickers";
import closeIcon from "../../../assets/icons/cross.png";
import { toast } from "react-toastify";

const AddItemScheduler = (props) => {
  const [supplyTimeEnabled, setSupplyTimeEnabled] = useState(false);
  const [supplyTime, setSupplyTime] = useState({
    date: "",
    time: "",
    quantity: "",
    startDate: "",
    endDate: "",
  });
  const [selectedDay, setSelectedDay] = useState("");
  const [editingMode, setEditingMode] = useState(false);
  const { sectionId, addedSchedulers, handleInventorySave,sectionTitle} = props;
  const [sectionData, setSectionData] = useState({});
  console.log(sectionTitle)
  console.log(sectionData)
console.log(addedSchedulers)
const scheduleDateTimeId =addedSchedulers[0]?.scheduleDateTimes[0]?.scheduleDateTimeId || null;
  /* Resetting Value to add new supply data */
  const addNewSupplyTimeButtonClicked = () => {
    setEditingMode(false);
    setSupplyTimeEnabled(true);
    setSupplyTime({
      date: "",
      time: "",
      quantity: "",
      startDate: "",
      endDate: "",
    });
  };

  const handleDateChange = (event, field) => {
    setSupplyTime((prevState) => ({
      ...prevState,
      [field]: event.target.value,
    }));
  };

  const selectDay = (day) => {
    switch (day) {
      case "Saturday":
        setSupplyTime((prevState) => ({ ...prevState, date: "Saturday" }));
        setSelectedDay("Saturday");
        break;
      case "Sunday":
        setSupplyTime((prevState) => ({ ...prevState, date: "Sunday" }));
        setSelectedDay("Sunday");
        break;
      case "Monday":
        setSupplyTime((prevState) => ({ ...prevState, date: "Monday" }));
        setSelectedDay("Monday");
        break;
      case "Tuesday":
        setSupplyTime((prevState) => ({ ...prevState, date: "Tuesday" }));
        setSelectedDay("Tuesday");
        break;
      case "Wednesday":
        setSupplyTime((prevState) => ({ ...prevState, date: "Wednesday" }));
        setSelectedDay("Wednesday");
        break;
      case "Thursday":
        setSupplyTime((prevState) => ({ ...prevState, date: "Thursday" }));
        setSelectedDay("Thursday");
        break;
      case "Friday":
        setSupplyTime((prevState) => ({ ...prevState, date: "Friday" }));
        setSelectedDay("Friday");
        break;
      default:
        setSupplyTime((prevState) => ({ ...prevState, date: "No day" }));
    }
  };

  const setQuantity = (data, eventValue) => {
    try {
      setSupplyTimeCollection((prevCollection) =>
        prevCollection.map((item) =>
          item === data ? { ...item, quantity: eventValue } : item
        )
      );
    } catch (e) {
      alert(e);
    }
  };

  const setTime = (data, event) => {
    setSupplyTimeCollection((prevCollection) =>
      prevCollection.map((item) =>
        item === data ? { ...item, time: event } : item
      )
    );
  };

  const selectTime = (event) => {
    setSupplyTime((prevState) => ({ ...prevState, time: event.target.value }));
  };

  const [supplyTimeCollection, setSupplyTimeCollection] = useState([]);

  const handleAddSupplyTime = () => {
    if (supplyTime.time !== "") {
      setSupplyTimeCollection([...supplyTimeCollection, supplyTime]);
      setSupplyTime({
        date: "",
        time: "",
        quantity: "1",
        startDate: "",
        endDate: "",
      });
      setSupplyTimeEnabled(false);
      setSelectedDay("");
    } else {
      alert("Field Is Empty");
    }
  };
  const handleClose = () => {
    props.handleClose(false);
  };
  const [dailyDiscarded, setDailyDiscarded] = useState(false);

  /* Any WeekDay or Specific Day Range */
  const [anyWeekdayEnable, setAnyWeekDayEnable] = useState(true);
  const [specificDayRangeEnable, setDaySpecificRangeEnable] = useState(false);
  const [indexOfEditedValue, setIndexOfEditedValue] = useState("");

  /* Supply Time Remove */
  const handleRemoveSupplyTime = (index) => {
    setSupplyTimeCollection(supplyTimeCollection.filter((_, i) => i !== index));
  };

  /* Edit Supply Time Popup Functionality */
  const editSupplyTime = (data, index) => {
    setEditingMode(true);
    setSupplyTimeEnabled(true);
    setIndexOfEditedValue(index);

    if (data.date !== "") {
      setAnyWeekDayEnable(true);
      setSupplyTime({
        date: data.date,
        time: data.time,
        quantity: data.quantity,
        startDate: data.startDate,
        endDate: data.endDate,
      });
      setSelectedDay(data.date);
    } else {
      setDaySpecificRangeEnable(true);
      setSupplyTime({
        date: data.date,
        time: data.time,
        quantity: data.quantity,
        startDate: data.startDate,
        endDate: data.endDate,
      });
    }
  };

  /* Save The Edited Value */
  const handleEditSupplyTime = () => {
    const updatedCollection = supplyTimeCollection.map((item, index) =>
      index === indexOfEditedValue ? { ...supplyTime } : item
    );
    setSupplyTimeCollection(updatedCollection);
    setSupplyTimeEnabled(false);
  };

  /* Resupply Time Functionality */
  const [resupplyTime, setResupplyTime] = useState({
    date: "",
    quantity: "",
    discardRemaining: false,
  });
  const [resupplyTimeEnabled, setReSupplyTimeEnabled] = useState(false);

  const [resupplyTimeCollection, setResupplyTimeCollection] = useState([]);

  const addResupply = () => {
    if (resupplyTime.date !== "" && resupplyTime.quantity !== "") {
      resupplyTime.id = resupplyTimeCollection.length;
      resupplyFrequency.supplyTypeId = 2;
      setResupplyTimeCollection([...resupplyTimeCollection, resupplyTime]);
      setResupplyTime({ date: "", quantity: "", discardRemaining: false });
      setSelectedDay("");
    } else {
      alert("Please Fill all the input field");
    }
  };
  const deleteResupply = (id) => {
    var list = resupplyTimeCollection.filter((x) => x.id != id);
    setResupplyTimeCollection(list);
  };

const handleSave = () => {
  const restaurant = JSON.parse(localStorage.getItem("restaurant"));

  const firstSupplyData = addDataToFirstSchedule(); // Call the function to get the data

  // Check if `firstSupplyData` is not null
  if (!firstSupplyData) {
     toast.error("Please add First supply time.", {
            position: "top-right",
            autoClose: 5000,
            hideProgressBar: false,
            closeOnClick: true,
            pauseOnHover: true,
            draggable: true,
            progress: undefined,
            theme: "colored",
          });
    return; // Exit the function if validation fails
  }

  const obj = {
    inventoryCategoryTypeId: 3,
    inventoryCategoryContentId: " ",
    restaurantId: restaurant.id,
    salesHourSetupId: "string",
    descriedDailyItem: dailyDiscarded,
    inventoryFirstSupplyPostViews: firstSupplyData, // Use validated data
    inventoryResupplyPostViews: addResupplyUnit(),
    SchedulerId: props.addedSchedulers.map(schedule => schedule.scheduleId)[0] || null,
    sectionId: sectionId,
    CreationId: "",
  };

  console.log("Save data for section:", props.sectionId, obj);

  setSectionData(prevState => ({
    ...prevState,
    [props.sectionId]: obj, 
  }));

  props.handleInventoryDetails({
    [props.sectionId]: obj, 
  });

  console.log(sectionData);
};


  const getTrueDays = (daysObject) => {
    const result = [];

    if (daysObject?.isSunday) result.push(0);
    if (daysObject?.isMonday) result.push(1);
    if (daysObject?.isTuesday) result.push(2);
    if (daysObject?.isWednesday) result.push(3);
    if (daysObject?.isThursday) result.push(4);
    if (daysObject?.isFriday) result.push(5);
    if (daysObject?.isSaturday) result.push(6);

    return result;
  };

  const getDayEnumFromString = (dayString) => {
    switch (dayString) {
      case "Sunday":
        return 0;
      case "Monday":
        return 1;
      case "Tuesday":
        return 2;
      case "Wednesday":
        return 3;
      case "Thursday":
        return 4;
      case "Friday":
        return 5;
      case "Saturday":
        return 6;
      default:
        return null; // Return null if the input doesn't match any day
    }
  };
  // const addDataToFirstSchedule = () => {
  //   var list = [];

  //     addedSchedulers.map((scheduler, i) => {
  //     scheduler.scheduleDateTimes.map((dateData, j) => {
  //       var obj = {};
  //       if (dateData.isDays) {
  //         obj = {
  //           fromDate: null,
  //           toDate: null,
  //           isDay: dateData.isDays,
  //           day: getTrueDays(dateData.scheduleDays[0]),
  //           time: dateData.time ? dateData.time + ":00" : "00:00:00",
  //           quantity: dateData.quantity,
  //           scheduleDateTimeId:scheduleDateTimeId,
  //         };
  //       } else {
  //         obj = {
  //           fromDate: dateData.fromDate,
  //           toDate: dateData.toDate,
  //           isDay: dateData.isDays,
  //           day: getTrueDays(dateData.scheduleDays[0]),
  //           time: dateData.time ? dateData.time + ":00" : "00:00:00",
  //           quantity: dateData.quantity,
  //           scheduleDateTimeId:scheduleDateTimeId,
  //         };
  //       }
  //       if (obj) {
  //         list.push(obj);
  //       }
  //     });
  //   });
  //   // supplyTimeCollection.map((supply, index) => {
  //   //   const dayArray = supply.dayStrings
  //   //     .map(getDayEnumFromString)
  //   //     .filter((day) => day !== null);

  //   //   const obj = {
  //   //     fromDate: supply.startDate,
  //   //     toDate: supply.endDate,
  //   //     isDay: dayArray ? true : false,
  //   //     day: dayArray ? dayArray : null,
  //   //     time: supply.time,
  //   //     quantity: supply.quantity,
  //   //   };
  //   //   list.push(obj);
  //   // });

  //   return list;
  // };


  const addDataToFirstSchedule = () => {
    var list = [];
  
    addedSchedulers.forEach((scheduler) => {
      scheduler.scheduleDateTimes.forEach((dateData) => {
        var obj = {};
  
        // Use the fromTime from addedSchedulers if time is not provided
        const time = dateData.time ? dateData.time + ":00" : dateData.fromTime;
  
        // Set quantity to 999 if not provided
        const quantity = dateData.quantity ? dateData.quantity : 999;
  
        if (dateData.isDays) {
          obj = {
            fromDate: null,
            toDate: null,
            isDay: dateData.isDays,
            day: getTrueDays(dateData.scheduleDays[0]),
            time: time,
            quantity: quantity,
            scheduleDateTimeId: dateData.scheduleDateTimeId,
          };
        } else {
          obj = {
            fromDate: dateData.fromDate,
            toDate: dateData.toDate,
            isDay: dateData.isDays,
            day: getTrueDays(dateData.scheduleDays[0]),
            time: time,
            quantity: quantity,
            scheduleDateTimeId: dateData.scheduleDateTimeId,
          };
        }
  
        if (obj) {
          list.push(obj);
        }
      });
    });
  
    return list;
  };

  const addResupplyUnit = () => {
    var obj = {
      supplyTypeId: 0,
      SupplyTime: "2024-10-14T11:04:41.227Z",
      frequency: 0,
      quantity: 0,
      endTime: {
        ticks: 0,
        days: 0,
        hours: 0,
        milliseconds: 0,
        minutes: 0,
        seconds: 0,
      },
      isDiscarded: true,
    };
    var list = [];
    resupplyFrequencyCollection.map((dt) => {
      obj = {
        supplyTypeId: dt.supplyTypeId,
        SupplyTime: dt.date,
        frequency: dt.hour,
        quantity: dt.quantity,
        endTime: dt.endTime,
        isDiscarded: dt.discardRemaining,
      };
      list.push(obj);
    });
    resupplyTimeCollection.map((dt) => {
      obj = {
        supplyTypeId: 2,
        SupplyTime: dt.date,
        frequency: 0,
        quantity: dt.quantity,
        endTime: null,
        isDiscarded: dt.discardRemaining,
      };
      list.push(obj);
    });
    return list;
  };

  /* Automatic Toggling Selection */
  useEffect(() => {
    if (anyWeekdayEnable === true) {
      setDaySpecificRangeEnable(false);
    } else {
      setDaySpecificRangeEnable(true);
    }
  }, [anyWeekdayEnable]);

  useEffect(() => {
    if (specificDayRangeEnable === true) {
      setAnyWeekDayEnable(false);
    } else {
      setAnyWeekDayEnable(true);
    }
  }, [specificDayRangeEnable]);

  /* Resupply Frequency */
  const [resupplyFrequencyEnable, setResupplyFrequencyEnable] = useState(false);
  const hour = [
    1, 2, 3, 4, 5, 6, 7, 8, 9, 10, 11, 12, 13, 14, 15, 16, 17, 18, 19, 20, 21,
    22, 23, 24,
  ];

  const [resupplyFrequency, setResupplyFrequency] = useState({
    date: "",
    hour: "",
    quantity: "",
    discardRemaining: false,
  });
  const [endTime, setEndTime] = useState();
  const [resupplyFrequencyCollection, setResupplyFrequencyColletion] = useState(
    []
  );

  const addResupplyFrequency = () => {
    if (
      resupplyFrequency.date !== "" &&
      resupplyFrequency.quantity !== "" &&
      resupplyFrequency.hour !== ""
    ) {
      resupplyFrequency.id = resupplyFrequencyCollection.length;
      resupplyFrequency.supplyTypeId = 3;

      setResupplyFrequencyColletion([
        ...resupplyFrequencyCollection,
        resupplyFrequency,
      ]);
      setResupplyFrequency({
        date: "",
        hour: "",
        quantity: "",
        endTime: "",
        discardRemaining: false,
      });
    } else {
      alert("Please Fill all the input field");
    }
  };
  const handleDeleteFromResupplyFrequencyCollection = (id) => {
    var updatedList = resupplyFrequencyCollection.filter((x) => x.id != id);
    setResupplyFrequencyColletion(updatedList);
  };


  console.log(supplyTimeCollection);
  return (
    <div className="mt-5">
      {/* First Supply Time */}

      <div className="">
        <div
          className="first-supply-time"
          style={{ opacity: supplyTimeEnabled ? ".5" : "1" }}
        >
          <p style={{ minWidth: "200px" }}>First Supply Time</p>
          <div>
            <TableContainer>
              <Table>
                <TableHead>
                  <TableRow>
                    <TableCell
                      className="text-center"
                      sx={{ backgroundColor: "#939193" }}
                    >
                      Date
                    </TableCell>
                    <TableCell
                      className="text-center"
                      sx={{ backgroundColor: "#939193" }}
                    >
                      Time
                    </TableCell>
                    <TableCell
                      className="text-center"
                      sx={{ backgroundColor: "#939193" }}
                    >
                      Quantity
                    </TableCell>
                    <TableCell
                      className="text-center"
                      sx={{ backgroundColor: "#939193" }}
                    >
                      Action
                    </TableCell>
                  </TableRow>
                </TableHead>
                <TableBody>
                  {addedSchedulers.map((scheduler, i) => {
                    return scheduler.scheduleDateTimes.map((dateData, j) => {
                      return (
                        <TableRow>
                          <TableCell className="text-center">
                            {dateData.isDays ? (
                              <>
                                {dateData.scheduleDays.map((scheduleday, k) => {
                                  return (
                                    <div
                                      className={`d-flex `}
                                      style={{
                                        gap: "10px",
                                        justifyContent: "center",
                                      }}
                                    >
                                      <button
                                        className={` circleBtn ${
                                          scheduleday.isSaturday
                                            ? "colorSelected "
                                            : "colorNotSelected"
                                        } `}
                                      >
                                        S
                                      </button>
                                      <button
                                        className={` circleBtn ${
                                          scheduleday.isMonday
                                            ? "colorSelected "
                                            : "colorNotSelected"
                                        } `}
                                      >
                                        M
                                      </button>
                                      <button
                                        className={` circleBtn ${
                                          scheduleday.isTuesday
                                            ? "colorSelected "
                                            : "colorNotSelected"
                                        } `}
                                      >
                                        T
                                      </button>
                                      <button
                                        className={` circleBtn ${
                                          scheduleday.isWednesday
                                            ? "colorSelected "
                                            : "colorNotSelected"
                                        } `}
                                      >
                                        W
                                      </button>
                                      <button
                                        className={` circleBtn ${
                                          scheduleday.isThursday
                                            ? "colorSelected "
                                            : "colorNotSelected"
                                        } `}
                                      >
                                        T
                                      </button>
                                      <button
                                        className={` circleBtn ${
                                          scheduleday.isFriday
                                            ? "colorSelected "
                                            : "colorNotSelected"
                                        } `}
                                      >
                                        F
                                      </button>
                                      <button
                                        className={` circleBtn ${
                                          scheduleday.isSunday
                                            ? "colorSelected "
                                            : "colorNotSelected"
                                        } `}
                                      >
                                        S
                                      </button>
                                    </div>
                                  );
                                })}
                              </>
                            ) : (
                              <>
                                {new Date(dateData.fromDate).toLocaleDateString(
                                  "en-GB",
                                  {
                                    day: "2-digit",
                                    month: "short",
                                    year: "numeric",
                                  }
                                )}{" "}
                                -{" "}
                                {new Date(dateData.toDate).toLocaleDateString(
                                  "en-GB",
                                  {
                                    day: "2-digit",
                                    month: "short",
                                    year: "numeric",
                                  }
                                )}
                              </>
                            )}{" "}
                            (
                            {dateData.isAllDay ? (
                              <>All Day</>
                            ) : (
                              <>
                                {new Date(
                                  "1970-01-01T" + dateData.fromTime
                                ).toLocaleTimeString("en-US", {
                                  hour: "2-digit",
                                  minute: "2-digit",
                                  hour12: true,
                                })}{" "}
                                -{" "}
                                {new Date(
                                  "1970-01-01T" + dateData.toTime
                                ).toLocaleTimeString("en-US", {
                                  hour: "2-digit",
                                  minute: "2-digit",
                                  hour12: true,
                                })}
                              </>
                            )}
                            )
                          </TableCell>
                          <TableCell className="text-center">
                            <input
                              type="time"
                              // value={supply.time}
                              onChange={(e) => (dateData.time = e.target.value)}
                              style={{
                                border: "none",
                                minWidth: "203px",
                                padding: "5px 10px",
                              }}
                            />
                          </TableCell>
                          <TableCell className="text-center">
                            <input
                              type="number"
                              // value={supply.quantity}
                              onChange={(e) =>
                                (dateData.quantity = e.target.value)
                              }
                              style={{
                                borderRadius: "5px",
                                minWidth: "203px",
                                padding: "5px 10px",
                                borderColor: "lightgray",
                                border: ".5px solid lightgray",
                              }}
                              placeholder="Select Quantity"
                            />
                          </TableCell>
                          <TableCell
                            className="text-center"
                            style={{
                              minWidth: "120px",
                              pointerEvents: "none",
                              filter: "grayscale(100%) opacity(50%)",
                              backgroundColor: "#f0f0f0",
                            }}
                          >
                            <IconButton
                              // onClick={() => editSupplyTime(supply, index)}
                              aria-label="edit"
                            >
                              <EditCalendarIcon style={{ color: "blue" }} />
                            </IconButton>
                            <IconButton
                              // onClick={() => handleRemoveSupplyTime(index)}
                              aria-label="delete"
                            >
                              <DeleteIcon style={{ color: "maroon" }} />
                            </IconButton>
                          </TableCell>
                        </TableRow>
                      );
                    });
                  })}
                  {supplyTimeCollection.map((supply, index) => (
                    <TableRow>
                      <TableCell className="text-center">
                        <p style={{ fontWeight: "400" }}>{supply.date}</p>
                        {supply.startDate && (
                          <p style={{ fontWeight: "300" }}>
                            {supply.startDate} to {supply.endDate}
                          </p>
                        )}
                      </TableCell>
                      <TableCell className="text-center">
                        <input
                          type="time"
                          value={supply.time}
                          onChange={(e) => setTime(supply, e.target.value)}
                          style={{
                            border: "none",
                            minWidth: "203px",
                            padding: "5px 10px",
                          }}
                        />
                      </TableCell>
                      <TableCell className="text-center">
                        <input
                          type="number"
                          value={supply.quantity}
                          onChange={(e) => setQuantity(supply, e.target.value)}
                          style={{
                            borderRadius: "5px",
                            minWidth: "203px",
                            padding: "5px 10px",
                            borderColor: "lightgray",
                            border: ".5px solid lightgray",
                          }}
                          placeholder="Select Quantity"
                        />
                      </TableCell>
                      <TableCell
                        style={{ minWidth: "120px" }}
                        className="text-center"
                      >
                        <IconButton
                          onClick={() => editSupplyTime(supply, index)}
                          aria-label="edit"
                        >
                          <EditCalendarIcon style={{ color: "blue" }} />
                        </IconButton>
                        <IconButton
                          onClick={() => handleRemoveSupplyTime(index)}
                          aria-label="delete"
                        >
                          <DeleteIcon style={{ color: "maroon" }} />
                        </IconButton>
                      </TableCell>
                    </TableRow>
                  ))}
                </TableBody>
              </Table>
            </TableContainer>

            <Button
              onClick={addNewSupplyTimeButtonClicked}
              style={{
                width: "200px",
                textDecoration: "underline",
                color: "black",
                float: "left",
              }}
            >
              + Add New Supply time
            </Button>
          </div>
        </div>

        <Modal open={supplyTimeEnabled}>
          <div className="newScheduler">
            <div className="title-newScheduler">
              <p>Create New Scheduler</p>
              <CloseIcon
                style={{ cursor: "pointer" }}
                onClick={() => setSupplyTimeEnabled(false)}
              />
            </div>
            <div className="newScheduler-container">
              <div className="schedule-first-row">
                <h5 style={{ marginRight: "100px" }}>Schedule</h5>
                <Switch
                  checked={anyWeekdayEnable}
                  onChange={() => setAnyWeekDayEnable(!anyWeekdayEnable)}
                />
                <p style={{ padding: "0px 20px" }}>Any Weekday -Or- </p>
                <Switch
                  checked={specificDayRangeEnable}
                  onChange={() =>
                    setDaySpecificRangeEnable(!specificDayRangeEnable)
                  }
                />
                <p style={{ padding: "0px 20px" }}>Specify date range</p>
              </div>
              {anyWeekdayEnable && !specificDayRangeEnable && (
                <div className="popup1">
                  <div className="day">
                    <button
                      className="days"
                      style={{
                        backgroundColor:
                          selectedDay === "Sunday"
                            ? "rgb(52, 152, 219, .5)"
                            : "",
                      }}
                      onClick={() => selectDay("Sunday")}
                    >
                      S
                    </button>
                    <button
                      className="days"
                      style={{
                        backgroundColor:
                          selectedDay === "Monday"
                            ? "rgb(52, 152, 219, .5)"
                            : "",
                      }}
                      onClick={() => selectDay("Monday")}
                    >
                      M
                    </button>
                    <button
                      className="days"
                      style={{
                        backgroundColor:
                          selectedDay === "Tuesday"
                            ? "rgb(52, 152, 219, .5)"
                            : "",
                      }}
                      onClick={() => selectDay("Tuesday")}
                    >
                      T
                    </button>
                    <button
                      className="days"
                      style={{
                        backgroundColor:
                          selectedDay === "Wednesday"
                            ? "rgb(52, 152, 219, .5)"
                            : "",
                      }}
                      onClick={() => selectDay("Wednesday")}
                    >
                      W
                    </button>
                    <button
                      className="days"
                      style={{
                        backgroundColor:
                          selectedDay === "Thursday"
                            ? "rgb(52, 152, 219, .5)"
                            : "",
                      }}
                      onClick={() => selectDay("Thursday")}
                    >
                      T
                    </button>
                    <button
                      className="days"
                      style={{
                        backgroundColor:
                          selectedDay === "Friday"
                            ? "rgb(52, 152, 219, .5)"
                            : "",
                      }}
                      onClick={() => selectDay("Friday")}
                    >
                      F
                    </button>
                    <button
                      className="days"
                      style={{
                        backgroundColor:
                          selectedDay === "Saturday"
                            ? "rgb(52, 152, 219, .5)"
                            : "",
                      }}
                      onClick={() => selectDay("Saturday")}
                    >
                      S
                    </button>
                  </div>

                  <div className="select-time">
                    <Typography style={{ minWidth: "100px" }}>
                      Select Time
                    </Typography>
                    <input
                      style={{ minWidth: "350px" }}
                      type="time"
                      id="appt"
                      name="appt"
                      className="form-control"
                      value={supplyTime.time}
                      onChange={selectTime}
                    />
                  </div>
                </div>
              )}

              {specificDayRangeEnable && !anyWeekdayEnable && (
                <div className="popup2">
                  <div className="from-to">
                    <Typography>From</Typography>
                    <input
                      type="date"
                      className="form-control"
                      value={supplyTime.startDate}
                      onChange={(e) => handleDateChange(e, "startDate")}
                    />
                    <Typography> To </Typography>
                    <input
                      type="date"
                      className="form-control"
                      value={supplyTime.endDate}
                      onChange={(e) => handleDateChange(e, "endDate")}
                    />
                  </div>
                  <div className="select-time">
                    <Typography style={{ minWidth: "100px" }}>
                      Select Time
                    </Typography>
                    <input
                      type="time"
                      id="appt"
                      name="appt"
                      className="form-control"
                      onChange={selectTime}
                      value={supplyTime.time}
                    />
                  </div>
                </div>
              )}
            </div>
            <Button
              onClick={editingMode ? handleEditSupplyTime : handleAddSupplyTime}
              style={{
                marginTop: "10px",
                marginBottom: "10px",
                marginLeft: "auto",
                display: "block",
                float: "right",
                padding: "10px 40px",
                backgroundColor: "lightgray",
              }}
            >
              {editingMode ? "Edit" : "Add"}
            </Button>
          </div>
        </Modal>

        {/* Resupply Frequency Start */}

        <div
          className="resupply-frequency"
          style={{ opacity: supplyTimeEnabled ? ".5" : "1" }}
        >
          <p style={{ minWidth: "200px" }}>Resupply Frequency</p>
          <Switch
            onChange={() => {
              setResupplyFrequencyEnable(!resupplyFrequencyEnable);
              setReSupplyTimeEnabled(false);
            }}
            checked={resupplyFrequencyEnable}
            disabled={!resupplyFrequencyEnable}
          />
        </div>

        {resupplyFrequencyEnable && (
          <div
            className="resupply-container d-flex"
            style={{ opacity: supplyTimeEnabled ? ".5" : "1" }}
          >
            <div className="resupply-input">
              <LocalizationProvider dateAdapter={AdapterDayjs}>
                <DateTimePicker
                  className="date-time-mui"
                  label="Select Date and Time"
                  onChange={(newValue) => {
                    setResupplyFrequency({
                      ...resupplyFrequency,
                      date: newValue,
                    });
                  }}
                  // value={resupplyFrequency.date !== "" ? '' : resupplyFrequency.date}
                  renderInput={(params) => <TextField {...params} fullWidth />}
                />
              </LocalizationProvider>
              <Box style={{ minWidth: "180px" }}>
                <FormControl fullWidth>
                  <InputLabel id="demo-simple-select-label">
                    Frequency In Hour
                  </InputLabel>
                  <Select
                    className="date-time-mui"
                    labelId="demo-simple-select-label"
                    id="demo-simple-select"
                    // value={selectedHour}
                    label="Frequency In Hour"
                    onChange={(e) =>
                      setResupplyFrequency({
                        ...resupplyFrequency,
                        hour: e.target.value,
                      })
                    }
                  >
                    {hour.map((hourValue) => (
                      <MenuItem key={hourValue} value={hourValue}>
                        {hourValue} Hour
                      </MenuItem>
                    ))}
                  </Select>
                </FormControl>
              </Box>

              <input
                type="number"
                id="appt"
                name="appt"
                className="form-control"
                style={{ maxWidth: "200px", height: "58px" }}
                value={resupplyFrequency.quantity}
                onChange={(e) =>
                  setResupplyFrequency({
                    ...resupplyFrequency,
                    quantity: e.target.value,
                  })
                }
                placeholder="Quantity"
              />
              <LocalizationProvider dateAdapter={AdapterDayjs}>
                <TimePicker
                  className="date-time-mui"
                  label="End Time"
                  value={resupplyFrequency.endTime}
                  onChange={(newValue) =>
                    setResupplyFrequency({
                      ...resupplyFrequency,
                      endTime: newValue,
                    })
                  }
                />
              </LocalizationProvider>

              <div className="d-flex" style={{ alignItems: "center" }}>
                <Checkbox
                  checked={resupplyFrequency.discardRemaining || false}
                  onChange={(e) =>
                    setResupplyFrequency({
                      ...resupplyFrequency,
                      discardRemaining: e.target.checked,
                    })
                  }
                />

                <p style={{ textWrap: "nowrap", padding: 0 }}>
                  Discard Remaining Items
                </p>
              </div>
            </div>
            <Button
              onClick={addResupplyFrequency}
              style={{
                marginTop: "10px",
                marginBottom: "10px",
                marginLeft: "auto",
                display: "block",
                float: "right",
                padding: "10px 40px",
                backgroundColor: "lightgray",
              }}
            >
              Add
            </Button>

            <table style={{ width: "100%", backgroundColor: "none" }}>
              <thead>
                <tr>
                  <th>Date & Time</th>
                  <th>Frequency In Hour</th>
                  <th>End Time</th>
                  <th>Quantity</th>
                  <th>Discard Remaining Items</th>
                  <th>Actions</th>
                </tr>
              </thead>

              <tbody>
                {resupplyFrequencyCollection.map((data, index) => (
                  <tr key={index}>
                    <td style={{ fontWeight: "400" }} className="text-center">
                      {data.date
                        ? data.date.format("DD-MM-YYYY hh:mm A")
                        : "No Date"}
                    </td>
                    <td style={{ fontWeight: "400" }} className="text-center">
                      {data.hour}
                    </td>
                    <td style={{ fontWeight: "400" }} className="text-center">
                      {data.endTime.format("hh:mm A")}
                    </td>
                    <td style={{ fontWeight: "400" }} className="text-center">
                      {data.quantity === "" ? "empty" : data.quantity}
                    </td>
                    <td style={{ fontWeight: "400" }} className="text-center">
                      {data.discardRemaining === true ? "Yes" : "No"}
                    </td>
                    <td className="text-center">
                      <img
                        src={closeIcon}
                        style={{ width: "1rem" }}
                        onClick={() => {
                          handleDeleteFromResupplyFrequencyCollection(data.id);
                        }}
                      />
                    </td>
                  </tr>
                ))}
              </tbody>
            </table>
          </div>
        )}

        {/* Supply Time Start */}

        <div
          className="resupply-time"
          // style={{ opacity: supplyTimeEnabled ? ".5" : "1" }}
        >
          <p style={{ minWidth: "200px" }}>Resupply Time</p>
          <Switch
            onChange={() => {
              setResupplyFrequencyEnable(false);
              setReSupplyTimeEnabled(!resupplyTimeEnabled);
            }}
            checked={resupplyTimeEnabled}
            disabled={!resupplyTimeEnabled}
          />
        </div>
        {resupplyTimeEnabled && (
          <div
            className="resupply-container"
            // style={{ opacity: supplyTimeEnabled ? ".5" : "1" }}
          >
            <div className="resupply-input">
              <LocalizationProvider dateAdapter={AdapterDayjs}>
                <DateTimePicker
                  className="date-time-mui"
                  label="Select Date and Time"
                  onChange={(newValue) => {
                    setResupplyTime({ ...resupplyTime, date: newValue });
                  }}
                  // value={resupplyTime.date !== "" ? '' : resupplyTime.date}
                  renderInput={(params) => <TextField {...params} fullWidth />}
                />
              </LocalizationProvider>

              <input
                type="number"
                id="appt"
                name="appt"
                className="form-control"
                style={{ maxWidth: "250px", height: "58px" }}
                value={resupplyTime.quantity}
                onChange={(e) =>
                  setResupplyTime({ ...resupplyTime, quantity: e.target.value })
                }
                placeholder="Quantity"
              />
              <div className="d-flex" style={{ alignItems: "center" }}>
                <Checkbox
                  checked={resupplyTime.discardRemaining || false}
                  onChange={(e) =>
                    setResupplyTime({
                      ...resupplyTime,
                      discardRemaining: e.target.checked,
                    })
                  }
                />
                <p style={{ textWrap: "nowrap" }}>Discard Remaining Items</p>
              </div>
            </div>
            <Button
              onClick={addResupply}
              style={{
                marginTop: "10px",
                marginBottom: "10px",
                marginLeft: "auto",
                display: "block",
                float: "right",
                padding: "10px 40px",
                backgroundColor: "lightgray",
              }}
            >
              Add
            </Button>

            <table style={{ width: "100%", backgroundColor: "none" }}>
              <thead>
                <tr>
                  <th>Date & Time</th>
                  <th>Quantity</th>
                  <th>Discard Remaining Items</th>
                  <th>Action</th>
                </tr>
              </thead>

              <tbody>
                {resupplyTimeCollection.map((data, index) => (
                  <tr key={index}>
                    <td style={{ fontWeight: "400" }}>
                      {data.date
                        ? data.date.format("YYYY-MM-DD HH:mm:ss")
                        : "No Date"}
                    </td>
                    <td style={{ fontWeight: "400" }}>
                      {data.quantity === "" ? "empty" : data.quantity}
                    </td>
                    <td style={{ fontWeight: "400" }}>
                      {data.discardRemaining === true ? "Yes" : "No"}
                    </td>
                    <td className="text-center">
                      <img
                        src={closeIcon}
                        style={{ width: "1rem" }}
                        onClick={() => {
                          deleteResupply(data.id);
                        }}
                      />
                    </td>
                  </tr>
                ))}
              </tbody>
            </table>
          </div>
        )}

        {/* Daily Remaining */}
        <div
          className="daily-remaining"
          style={{
            display: "flex",
            flexDirection: "row",
            alignItems: "center",
            opacity: supplyTimeEnabled ? ".5" : "1",
            marginTop: "10px",
          }}
        >
          <p className="daily-remaining-label" style={{ minWidth: "200px" }}>
            Daily Remaining Items
          </p>
          <Switch
            checked={dailyDiscarded}
            onChange={() => setDailyDiscarded(!dailyDiscarded)}
          />
          <p>Discarded</p>
        </div>
        <div className="d-flex justify-content-end">
          <Button className="mt-2" color="success" onClick={handleSave}>
            Save Inventory for {sectionTitle} 
          </Button>
        </div>
      </div>
    </div>
  );
};

export default AddItemScheduler;
